import { fetchWithXsrf, getAntiForgeryToken } from "@siisel/frontend-shared";
import { useState } from "react";
import type { HistorizationSettingsFormViewModel } from "../types";

export default function HistorizationSettingsFormApp(props: HistorizationSettingsFormViewModel) {
  const [cronExpression, setCronExpression] = useState(props.values.cronExpression);
  const [dayLevels] = useState(props.values.dayLevels);
  const [nextDayLevels, setNextDayLevels] = useState(props.values.nextDayLevels);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  async function submit(root: HTMLElement | null) {
    if (isSubmitting || !props.canEdit) {
      return;
    }

    setIsSubmitting(true);
    setErrorMessage(null);

    try {
      const formData = new FormData();
      const token = getAntiForgeryToken(root);
      if (token) {
        formData.append("__RequestVerificationToken", token);
      }

      formData.append("CronExpression", cronExpression);
      formData.append("DayLevels", dayLevels);
      formData.append("NextDayLevels", nextDayLevels);
      formData.append("saveAndClose", "false");

      const response = await fetchWithXsrf(props.submitUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "text/html"
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error(await response.text());
      }

      window.location.reload();
    } catch (error) {
      setErrorMessage(error instanceof Error ? error.message : "Ulozeni se nepodarilo.");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="forms-app historization-settings-form-app">
      {errorMessage ? <div className="alert alert-danger">{errorMessage}</div> : null}
      <div className="base-form">
        <div className="form-group">
          <label htmlFor="historization-cron-expression">{props.labels.cronExpression}</label>
          <input
            id="historization-cron-expression"
            className="form-control"
            value={cronExpression}
            disabled={!props.canEdit || isSubmitting}
            onChange={(event) => {
              setCronExpression(event.currentTarget.value);
              setErrorMessage(null);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="historization-day-levels">{props.labels.dayLevels}</label>
          <input id="historization-day-levels" className="form-control" value={dayLevels} disabled />
        </div>
        <div className="form-group">
          <label htmlFor="historization-next-day-levels">{props.labels.nextDayLevels}</label>
          <input
            id="historization-next-day-levels"
            className="form-control"
            value={nextDayLevels}
            disabled={!props.canEdit || isSubmitting}
            onChange={(event) => {
              setNextDayLevels(event.currentTarget.value);
              setErrorMessage(null);
            }}
          />
          <p>{props.labels.changesInfo}</p>
        </div>
      </div>

      <div className="panel-footer">
        <button
          type="button"
          className="btn btn-success btn-sm"
          disabled={!props.canEdit || isSubmitting}
          onClick={(event) => void submit(event.currentTarget.closest(".forms-app"))}
        >
          <em className="fa fa-save"></em>
          {isSubmitting ? `${props.submitText}...` : props.submitText}
        </button>
      </div>
    </div>
  );
}
